import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieStorageService {
  get(name: string): string | null {
    const match = document.cookie.match(`(^|;)\\s*${name}=([^;]*)`);
    return match ? decodeURIComponent(match[2]) : null;
  }

  set(
    name: string,
    value: string,
    seconds: number,
    options: {
      path?: string;
      domain?: string;
      secure?: boolean;
      sameSite?: 'Strict' | 'Lax';
    } = {}
  ) {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (seconds) {
      const expires = new Date(Date.now() + seconds * 1000).toUTCString();
      cookieString += `; expires=${expires}`;
    }

    cookieString += `; Path=${options.path || '/'}`;

    if (options.sameSite) {
      cookieString += `; SameSite=${options.sameSite}`;
    }
    if (options.domain) {
      cookieString += `; Domain=${options.domain}`;
    }
    if (options.secure) {
      cookieString += `; Secure`;
    }

    document.cookie = cookieString;
  }

  has(name: string): boolean {
    return document.cookie.includes(`${encodeURIComponent(name)}=`);
  }

  delete(name: string, path = '/', domain?: string) {
    let cookieString = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
    if (domain) {
      cookieString += `; domain=${domain}`;
    }
    document.cookie = cookieString;
  }
}
